import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loadPayments } from './actions';
import { getChild } from '../reducer';
import List from './List';
import Grid from './Grid';
import ui from '../../common/services/ui';

class Payments extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		this.props.loadPayments(this.props.pagination);
	}

	handleListEvent(listPagination) {
		this.props.loadPayments(listPagination);
	}

	render() {
		const { data, pagination } = this.props;

		return <div>
			{ui.isMobileView ? <Grid data={data} onFetchData={this.handleListEvent} {...pagination} /> :
				<List data={data} onFetchData={this.handleListEvent} {...pagination}/>}
			</div>
	}
}

const mapStateToProps = state => {
	const { parent, entities: { payments, centers, terms, grades }, pagination, configuration: { franchisor } } = state;

	const paymentsPagination = pagination.payments.all || { ids: [], pageNumber: 1, pageSize: 10 };

	const visiblePayments = paymentsPagination.ids.map(id => payments[id]);
	visiblePayments.forEach(payment => {
		if (payment) {
			payment.child = getChild(parent, payment.childId);
			payment.center = centers[payment.centerId];

			if (payment.lesson) {
				payment.lesson.center = centers[payment.lesson.centerId];
				payment.lesson.term = terms[payment.lesson.termId];
				payment.lesson.grade = grades[payment.lesson.gradeId];
			}

		}
	});

	return {
		data: visiblePayments,
		pagination: paymentsPagination
	};
};

export default connect(mapStateToProps, {
	loadPayments
})(withTranslation()(Payments));